import axios from "axios";
import superAdminLoginService from "../../features/superAdmin/login/superAdminLoginService"
import { StorageService } from "../storageService/storageService";

// Create an instance of Axios
const superAdminAxiosInstance = axios.create();

// Add an interceptor to modify request data for every request
superAdminAxiosInstance.interceptors.request.use((config: any) => {
    // Attach the access token to every request
    const accessToken = StorageService.getObjStorage("super_admin_access_token");
    if (accessToken) {
        config.headers = config.headers || {};
        config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
});

// clearing local storage and redirecting to login page
const handleRedirect = () => {
    localStorage.removeItem("super_admin_user");
    localStorage.removeItem("super_admin_refresh_token");
    localStorage.removeItem("super_admin_access_token");
    window.location.href = "/superadmin/login";
};

// Refresh token queue and flag
let isRefreshing = false;
let failedQueue: any[] = [];

const processQueue = (error: any, token: string | null = null) => {
    failedQueue.forEach(prom => {
        if (token) {
            prom.resolve(token);
        } else {
            prom.reject(error);
        }
    });
    failedQueue = [];
};

// Intreceptor for checking every response
superAdminAxiosInstance.interceptors.response.use(
    (response: any) => response,
    async (error) => {
        const originalRequest = error.config;
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                // Wait for the refresh to finish, then retry
                return new Promise(function(resolve, reject) {
                    failedQueue.push({
                        resolve: (token: string) => {
                            originalRequest.headers = originalRequest.headers || {};
                            originalRequest.headers["Authorization"] = "Bearer " + token;
                            originalRequest.headers["authorization"] = "Bearer " + token;
                            console.log("Retrying with token (queue):", token);
                            resolve(superAdminAxiosInstance(originalRequest));
                        },
                        reject: (err: any) => {
                            reject(err);
                        }
                    });
                });
            }
            originalRequest._retry = true;
            isRefreshing = true;
            const userDetails: any = StorageService.getObjStorage("super_admin_user");
            const convertedUserDetails: any = JSON.parse(userDetails);
            try {
                const tokenResponse = await superAdminLoginService.superAdminRefreshToken(convertedUserDetails?.refresh_token);
                if (tokenResponse?.isSuccess) {
                    StorageService.setObjStorage("super_admin_access_token", tokenResponse?.result?.access_token);
                    processQueue(null, tokenResponse?.result?.access_token);
                    originalRequest.headers = originalRequest.headers || {};
                    originalRequest.headers["Authorization"] = `Bearer ${tokenResponse?.result?.access_token}`;
                    originalRequest.headers["authorization"] = `Bearer ${tokenResponse?.result?.access_token}` ;
                    return superAdminAxiosInstance(originalRequest);
                } else {
                    processQueue("Refresh failed", null);
                    handleRedirect();
                }
            } catch (err) {
                processQueue(err, null);
                handleRedirect();
            } finally {
                isRefreshing = false;
            }
        }
        return Promise.reject(error);
    }
);

export default superAdminAxiosInstance;
